import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-seeyeun",
  data: function() {
    return {
      user_name: "",
      user_email: "",
      user_text: "",
      viewModel: {}
    };
  },
  mounted: function() {
    try {
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnClickMail: function() {
      let vm = this;
      if (!vm.isValidEmail(vm.user_email)) {
        alert("연락받을 메일의 형식이 틀렸습니다.");
        return false;
      }
      Axios.post("/seeyeun/mail", { user_name: vm.user_name, user_email: vm.user_email, user_text: vm.user_text })
        .then(function(response) {
          alert("메일이 발송되었습니다.");
          location.reload();
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }
  }
});



// WEBPACK FOOTER //
// ./src/uz/seeyeun/seeyeun-controller.js